/**
 * RISKS.POPULATIONS-ROUTE
 * Get all populations for
 */
import PopulationsFilterPanel from "@/entities/population/ui/PopulationsFilterPanel"
import Populations from "@/entities/population/ui/Populations"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"
import PopulationEditModal from "@/entities/population/ui/modal/PopulationEditModal"
import PageHeader from "@/components/page-header"
import NavEstablishment from "@/nav/nav.establishment"

function RisksPopulationsRoute() {
  //State
  const [modal, setModal] = useState<null | "MODAL_ADD">(null)

  return (
    <NavEstablishment
      actions={[
        {
          id: "ADD_POPULATION",
          icon: faPlus,
          label: "Ajouter une fonction",
          className: "primary",
          isLarge: true,
          onClick: () => setModal("MODAL_ADD")
        }
      ]}>
      {modal === "MODAL_ADD" && <PopulationEditModal isNew onClose={() => setModal(null)} />}

      <div className="flex fixed top-[48px] left-0 h-[calc(100%-48px)] app-content-width">
        <div className="py-20 pl-40 flex-1 flex flex-col overflow-auto">
          <PageHeader
            section="Risques"
            title="Fonctions"
            subtitle="Mettez à jour le niveau de risque pour chaque fonction de votre établissement."
          />
          <Populations />
        </div>
        <PopulationsFilterPanel />
      </div>
    </NavEstablishment>
  )
}

export default RisksPopulationsRoute
